import * as React from "react";
import { Box, Container } from "../../base";
import { Loader } from "@progress/kendo-react-indicators";
import "./CPLoaderStyles.scss";

interface CPLoaderProps {
  /** When `true`, renders a full-container overlay with a centered spinner. When `false`, renders `null`. */
  isLoading: boolean;
}

/**
 * Full-container loading overlay. Displays a centred infinite spinner on top of a semi-transparent
 * backdrop while `isLoading` is `true`; returns `null` otherwise.
 *
 * @example
 * ```tsx
 * <CPLoader isLoading={isFetchingData} />
 * ```
 */
const CPLoader: React.FC<CPLoaderProps> = ({ isLoading }) => {
  return isLoading ? (
    <Container className="cp-loader">
      <Box className="loader-overlay"></Box>
      <Box className="loader-spinner">
        <Loader type={"infinite-spinner"} size="large" />
      </Box>
    </Container>
  ) : null;
};

export default CPLoader;
